/**
 * Warning, make sure not to defer when importing this script.
 * It seems like alpine:init runs earlier than document.ready and the store will
 * fail to initialize if this is imported with a script tag that's deferred
 */

const assertDependenciesInstalled = () => {
  if (!window.cart) {
    throw new Error("Cart must be initialized globally to use sm-cart-alpine");
  }

  if (!SMCart) {
    throw new Error("sm-cart-alpine relies on SMCart for its events");
  }
}

document.addEventListener("alpine:init", () => {
  assertDependenciesInstalled();
  Alpine.store("cart", {
    ...window.cart,
    loading: {
      lineItemKeys: [],
      orderTotal: false,
    },
    isItemLoading(item) {
      return false;
    },
    setCartUpdates(cartUpdates) {
      console.log({ cartUpdates });
      // https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-change-js
      // Be careful of updating some values, looping through all keys and setting everything with:
      //  this[key] = cartUpdates[key];
      // caused me a weird shipping cost error on the checkout
      this.items = [...cartUpdates.items];
      this.item_count = cartUpdates.item_count;
      this.note = cartUpdates.note;
      this.original_total_price = cartUpdates.original_total_price;
      this.items_subtotal_price = cartUpdates.items_subtotal_price;
      this.total_discount = cartUpdates.total_discount;
      this.total_price = cartUpdates.total_price;
    },
    removeItem(item) {
      SMCart.dispatch({ type: "removeFromCart", id: item.key });
    },
    updateItemQty(item, quantity) {
      SMCart.dispatch({ type: "changeCart", id: item.key, quantity })
    },
    removeLoadingLine(id) {
      this.loading.lineItemKeys = [...this.loading.lineItemKeys].filter(lineItemKey => lineItemKey != id)
    }
  });

  const onChangeOrRemove = ({ id, cartUpdates }) => {
    Alpine.store("cart").removeLoadingLine(id);
    Alpine.store("cart").setCartUpdates(cartUpdates);
  }

  SMCart.on("changeCart", onChangeOrRemove);
  SMCart.on("removeFromCart", onChangeOrRemove);
});
